import React from "react"

export const Heading = ({title}) => {
  return (
    <>
      <h2 className="heading">{title}</h2>
    </>
  )
}

/* this component was reused in the about page */